import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=5861ac26"
import script from "./SearchFilters.vue?vue&type=script&lang=js"
export * from "./SearchFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1200771894/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5861ac26')) {
      api.createRecord('5861ac26', component.options)
    } else {
      api.reload('5861ac26', component.options)
    }
    module.hot.accept("./SearchFilters.vue?vue&type=template&id=5861ac26", function () {
      api.rerender('5861ac26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/promotions/SearchFilters.vue"
export default component.exports